import { CardBody, CardFooter } from '@execonline-inc/execonline-ui';
import clsx from 'clsx';
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import ExperienceCardBody from '../../../../ExperienceCardBody';
import ExperienceFooter from '../../../../ExperienceFooter';
import { ExperienceResource } from '../../../../Types';
import ExperienceVideoState from '../../../../../../ExperienceVideoState';
import ExperienceCardHeader from '../../../../../../ChatbotPreview/Previewer/Ready/Details/DefaultSection/ExperienceCard/ExperienceCardHeader';
import ExperienceSchoolThumbnail from '../../../../../../ChatbotPreview/Previewer/Ready/Details/DefaultSection/ExperienceCard/ExperienceSchoolThumbnail';
import UnlicensedBadge from '../../../../LicenseTracker/UnlicensedBadge';

export interface Props {
  experienceResource: ExperienceResource;
  sectionIndex: number;
  selectedDateIds?: Set<number>;
  onEditDates?: () => void;
  editable?: boolean;
}

function CardContent({
  experienceResource,
  sectionIndex: _sectionIndex,
  selectedDateIds,
  onEditDates,
  editable = false,
}: Props) {
  return (
    <div className="box-border h-full flex w-full relative group">
      <div tabIndex={-1} className="relative flex w-full h-full flex-col">
        <div
          data-testid="execonline-card"
          data-intercom-target="experience-card"
          className={clsx(
            'rounded-lg text-card-foreground box-border w-full h-full',
            'border border-border relative flex flex-col overflow-hidden',
            'bg-card',
            'hover:border-primary hover:shadow-lg transition-all',
          )}
        >
          <UnlicensedBadge
            productLicenseTypeIds={experienceResource.payload.product_license_type_ids}
            experienceId={just(experienceResource.payload.id)}
            licenseStartsOn={experienceResource.payload.license_starts_on}
          />
          <ExperienceVideoState
            experienceResource={experienceResource}
            className="h-[11.125rem] w-full flex-none rounded-t"
          >
            <ExperienceSchoolThumbnail experienceResource={experienceResource} />
          </ExperienceVideoState>
          <ExperienceCardHeader experienceResource={experienceResource} />
          <CardBody>
            <ExperienceCardBody
              experienceResource={experienceResource}
              selectedDateIds={selectedDateIds}
              onEditDates={onEditDates}
              editable={editable}
            />
          </CardBody>
          <CardFooter>
            <ExperienceFooter experienceResource={experienceResource} />
          </CardFooter>
        </div>
      </div>
    </div>
  );
}

export default observer(CardContent);
